// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// load (Polyfill) EventSource, in case browser does not support it...
import "@babel/polyfill";

import Vue from "vue";
import VModal from "vue-js-modal";
import VeeValidate from "vee-validate";
import FullCalendar from "vue-full-calendar";
import { BootstrapVue, ButtonGroupPlugin, CardPlugin, LayoutPlugin } from "bootstrap-vue";
import VueProgressBar from "vue-progressbar";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import { abilitiesPlugin } from "@casl/vue";
import App from "./App";
import router from "./router";
import store from "./store";
import { EventBus } from "./event-bus";
import VueAnalytics from "vue-analytics";
import adminRoute from "./_admin-nav";
import dashboardRoute from "./_nav";
import routerKeys from "@/store/router-keys";
import { ability } from "./store/ability";
import {
  READ,
  WRITE,
  EDIT,
  DELETE,
  VIEW_DETAIL,
  FORCE_DELETE
} from "@/store/modules/permissions/constants";
import constants from "@/_consts";
import momenttz from "moment-timezone";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-toastr/dist/vue-toastr.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "fullcalendar/dist/fullcalendar.css";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import 'vue2-timepicker/dist/VueTimepicker.css'

Vue.use(VueAnalytics, {
  id: process.env.GOOGLE_ANALYTICS_USER_ID,
  router,
  set: [
    { field: "userId", value: "N/A" },
    { field: "role", value: "" },
    { field: "employer_ids", value: "" }
  ],
  batch: {
    enabled: true,
    delay: 500,
    amount: 10
  }
});
Vue.use(FullCalendar);
Vue.use(BootstrapVue, ButtonGroupPlugin, CardPlugin, LayoutPlugin);
Vue.use(VueProgressBar, {
  color: "rgb(0, 181, 230)",
  failedColor: "red",
  height: "2px"
});
Vue.use(PerfectScrollbar);
Vue.use(VModal, { dialog: true });
Vue.use(VeeValidate, { inject: true, fieldsBagName: "veeFields" });
Vue.use(abilitiesPlugin, ability);

Vue.config.productionTip = false;

Vue.filter("textEllipsis", text => {
  const max = 60;
  if (text.length <= max) {
    return text;
  } else {
    return text.substring(0, max + 1) + "...";
  }
});

Vue.filter("timezone", (value, tz = "America/Los_Angeles") => {
  if (!value) return "";
  return momenttz.tz(value, tz).format("MM/DD/YYYY - hh:mm A");
});

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

Vue.prototype.$bus = EventBus;
Vue.prototype.$adminRoute = adminRoute;
Vue.prototype.$dashboardRoute = dashboardRoute;
Vue.prototype.$routerKeys = routerKeys;
Vue.prototype.$perName = {
  READ,
  WRITE,
  EDIT,
  DELETE,
  VIEW_DETAIL,
  FORCE_DELETE
};
Vue.prototype.$entities = constants.entities;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: { App },
  store,
  mounted: function() {
    // Attach event listener to the root vue element
    // this.$el.addEventListener('click', this.onClick)
    // Or if you want to affect everything
    document.addEventListener("click", this.onClick);
  },
  beforeDestroy: function() {
    // this.$el.removeEventListener('click', this.onClick)
    document.removeEventListener("click", this.onClick);
  },
  methods: {
    onClick: function() {
      // TODO: if we want to track all click event on page and sent to google analytics, examine the event params and use this.$ga.event('category', 'action', 'label', 123), please refer
      // https://github.com/MatteoGabriele/vue-analytics/blob/master/docs/event-tracking.md
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js